module.exports = __webpack_public_path__ + "img/gktitle.aece3ad5.png";